import { ClassNames, css } from '@emotion/react';
import { useAtomValue } from 'jotai';
import { FC, PropsWithChildren } from 'react';

import { blurAtom } from './blur-atom';

interface ConditionalBlurWrapperProps extends React.HTMLAttributes<HTMLDivElement> {}

export const ConditionalBlurWrapper: FC<PropsWithChildren<ConditionalBlurWrapperProps>> = ({
  children,
  className,
  ...props
}) => {
  const blurred = useAtomValue(blurAtom);

  return (
    <ClassNames>
      {({ cx }) => (
        <div
          {...props}
          className={cx(className, 'conditional-blur')}
          css={styles.wrapperStyle(blurred)}
          aria-hidden={blurred}
        >
          {children}
        </div>
      )}
    </ClassNames>
  );
};

const styles = {
  wrapperStyle: (blurred: boolean) =>
    css({
      pointerEvents: blurred ? 'none' : 'auto',
    }),
};
